import workspaceQuery from '../../../graphql/queries/salesLedger/AutomatedCreditControlScheduledEmailWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const AutomatedCreditControlScheduledEmail: EntityType = {
  type: 'AutomatedCreditControlScheduledEmail',
  title: 'Automated Credit Control Scheduled Email',
  formTitle: 'Automated Credit Control Scheduled Email',
  workspaceUrl: '/Customers/AutomatedCreditControlScheduledEmail/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'ACC_SCHEDULED_EMAIL',
};

export default AutomatedCreditControlScheduledEmail;
